'use client';

import { Dialog, Slide } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { useParams } from 'next/navigation';
import { forwardRef } from 'react';
import { useGetEvent } from 'src/api/events';
import { useResponsive } from 'src/hooks/use-responsive';
import MainLayout from 'src/layouts/main/layout';

const Transition = forwardRef(
  (
    props: TransitionProps & {
      children: React.ReactElement;
    },
    ref: React.Ref<unknown>
  ) => <Slide direction="left" ref={ref} {...props} />
);

type EventLayoutProps = {
  children: React.ReactNode;
};

export default function Layout({ children }: EventLayoutProps) {
  const mdDown = useResponsive('down', 'md');
  const { id } = useParams();
  const { data: event } = useGetEvent(id as string, null, false);
  // Extract the id from params
  // Always render the Dialog for mobile, even during loading
  if (mdDown) {
    return (
      <Dialog
        fullScreen
        open
        TransitionComponent={Transition}
        sx={{ '& .MuiDialog-paper': { borderRadius: 0 } }}
      >
        <MainLayout
          hideOption
          showTabBar={false}
          withLogo={false}
          noFooter
          theme={event?.configuration}
        >
          {children}
        </MainLayout>
      </Dialog>
    );
  }

  return (
    <MainLayout withProfile hideOption theme={event?.configuration}>
      {children}
    </MainLayout>
  );
}
